/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        buttonProps: {
            css: css`
                &&& {
                    z-index: ${props => getProp("theme.zIndex.menu", 0)(props) - 1};
                    width: 30px !important;
                    padding: 0;
                    border-radius: 50%;
                    background: ${getColor("common.border")};
                    height: 30px;

                    &&&:focus,
                    &&&:active {
                        background: ${getColor("common.ui4")};
                        border-color: ${getColor("common.ui4")};

                        span {
                            color: ${getColor("common.background")};
                        }
                    }
                }
            `,
        },
        iconProps: { size: 18, color: "common.ui2" },
        cssOverrides: {
            wrapper: css`
                width: 30px;
                height: 30px;
            `,
            menu: css`
                > * {
                    padding: 5px 0 0;
                }

                @media print {
                    display: none;
                }
            `,
            menuItem: css`
                && {
                    padding: 0;
                }
                &:first-child {
                    padding-top: 10px;
                }
                span,
                button {
                    width: 100%;
                }
                span,
                button,
                a {
                    display: block;
                    padding: 10px 15px;
                    &:hover {
                        background: ${getColor("common.border")};
                    }
                    &:active,
                    &:focus {
                        background: ${getColor("primary.main")};
                        color: ${getColor("primary.contrast")};
                    }
                }
            `,
        },
    },
} as xBaseTheme["overflowMenu"];
